import React, {useContext, useLayoutEffect, useState} from "react";
import {IStepTranscript} from "../../interfaces/IStepTranscript";
import {CardActionArea} from "@material-ui/core";
import {AppContext} from "../../App";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import {AppService} from "../../services/app.service";
import * as C from '../../utils/strings';


interface ISupportingContent{
    [key: string]: any
}

function Transcript(props: IStepTranscript){
    const context = useContext(AppContext);
    let finalTranscript: string = props.transcript;
    const [supportContent, setSupportContent] = useState<ISupportingContent>({"input-1": "-"})
    let currentStep: string = `${context.currentWeekNo}${context.currentTaskNo}${context.currentStepNo}`
    console.log(currentStep);
    // content related vars
    const[highestRank, setHighestRank] = useState<string>('..')

    /*
     EXCLUSIVE CUSTOM CONTENT
     -------------------------------------------------------- */
    // Week 1 - Task 7 - Step 3
    if(currentStep === '162'){
        // let rawResponse: any = context.quizResponse;
        // let pickedResponse = rawResponse[161];
        let pickedResponse = supportContent[161];
        // console.log("pickedResponse", pickedResponse);
        let count: number = 0;
        let replacement: string = "<ul>"

        if(pickedResponse !== undefined) {
            //select only those in odd inputs
            Object.entries(pickedResponse).forEach(
                ([key, value]) => {
                    if(isOdd(Number(key.split('-')[1]))){
                        replacement += `<li>${value}</li>`
                        count++;
                    }
                });
            replacement += "</ul>";
        } else {
            replacement += "</ul>";
        }

        //replacing will only happen if there is at least one reponse in the right column (odd number)
        if(count > 0) {
            finalTranscript = props.transcript.replace('[...]', replacement);
        }
    }

    //week 1 Task 12 Step 4
    if(currentStep === '1113'){

        //get result from Previous Survey
        let surveyResult: any = context.surveyResult
        console.log('result from previous survey');
        console.log(surveyResult);

        let mindset: string = surveyResult['mindset'];
        let average: number = surveyResult['average'];

        //compose result to render
        let resultHtml: string = `<p>Result Average: </p> <h1>${average}</h1>`

        // clean the transcript
        let cleanedUpTranscript = props.transcript.replace('[conditional]', '');
        let conditionalTranscriptObj = JSON.parse(cleanedUpTranscript);;
        finalTranscript = `${resultHtml} ${conditionalTranscriptObj[mindset]}`;
    }

    //week 4 Task 5 Step 3 git
    if(currentStep === '442'){
        let cleanedUpTranscript = props.transcript.replace('[conditional]', '');
        let conditionalTranscriptObj = JSON.parse(cleanedUpTranscript);
        finalTranscript = `${conditionalTranscriptObj[supportContent[441]]}`;

    }

    if(currentStep === "462") {
        let surveyResult: any = context.surveyResult
        let score: number = surveyResult['average']
        let translation: string = surveyResult['translatedResult']
        finalTranscript = `<h2>Score: ${score} (${translation})</h2> ${props.transcript}`
    }

    if(currentStep === '474'){
        let cleanedUpTranscript = props.transcript.replace('[conditional]', '');
        let conditionalTranscriptObj = JSON.parse(cleanedUpTranscript);
        finalTranscript = `${conditionalTranscriptObj[supportContent[473]]}`;
    }


    //getting highest rank
    if(currentStep === '292' || currentStep === '294'){
        let surveyResult: any = context.surveyResult
        let highestRank: string = surveyResult['highestRank'];

        let result: string = `<i>"${highestRank}"</i>`;
        finalTranscript = `${result} &nbsp ${props.transcript}`;
    }


    //retrieve previous survey.
    if(currentStep === '2100'){
        finalTranscript = props.transcript.replace('[xxx]', highestRank)
    }

    if(currentStep === '2101'){
        finalTranscript = props.transcript.replace('[xxx]', highestRank)
    }


    if(Number(context.currentWeekNo) === 1 &&
        Number(context.currentTaskNo) === 13 &&
        Number(context.currentStepNo) === 5)
    {
        let revision0: string = props.transcript.replace('[0]', supportContent[1132])
        let revision1: string = revision0.replace('[1]', supportContent[1133])
        let revision2: string = revision1.replace('[2]', supportContent[1134])
        finalTranscript = revision2
        // console.log('final screen', supportContent);
    }


    // content renderer
    // allows rendering of content with on the fly react component
    function renderContent(script: string){
        // some week has advance script content that uses react component
        let transcriptContent = (script === C.UNDEFINED) ? C.WAIT_INDICATOR : script;
        if (Number(context.currentWeekNo) === 2 &&
            Number(context.currentTaskNo) === 5 &&
            Number(context.currentStepNo) === 3) {

            const components: any = [];
            let raw: any = JSON.parse(props.transcript)
            // console.log(raw);
            let contentKey: number = 0;
            Object.entries(raw).forEach(
                ([key, value]) => {

                    let content: any = value
                    // console.log(content);
                    // console.log(Object.keys(content)[0]);
                    if(Object.keys(content)[0] === 'html'){
                        let htmlContent = content[Object.keys(content)[0]];
                        components.push(
                            <div key={`html-${contentKey}`} dangerouslySetInnerHTML={{__html: htmlContent}}/>
                        )
                    } else if (Object.keys(content)[0] === 'accordion') {
                        let accordionContent = content[Object.keys(content)[0]];
                        components.push(
                            <Accordion key={`accordion-${contentKey}`}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    {accordionContent['header']}
                                </AccordionSummary>
                                <AccordionDetails>
                                    <hr/>
                                    <div dangerouslySetInnerHTML={{__html: accordionContent['html']}}/>
                                </AccordionDetails>
                            </Accordion>
                        )
                    }

                    contentKey++;
                });

            return(
                <>
                    {components}
                </>
            )
        } else if (Number(context.currentWeekNo) === 2 &&
            Number(context.currentTaskNo) === 6 &&
            Number(context.currentStepNo) === 2) {

            const components: any = [];
            let raw: any = JSON.parse(props.transcript)
            // console.log(raw);
            let contentKey: number = 0;
            Object.entries(raw).forEach(
                ([key, value]) => {

                    let content: any = value
                    // console.log(content);
                    // console.log(Object.keys(content)[0]);
                    if(Object.keys(content)[0] === 'html'){
                        let htmlContent = content[Object.keys(content)[0]];
                        components.push(
                            <div key={`html-${contentKey}`} dangerouslySetInnerHTML={{__html: htmlContent}}/>
                        )
                    } else if (Object.keys(content)[0] === 'accordion') {
                        let accordionContent = content[Object.keys(content)[0]];
                        components.push(
                            <Accordion key={`accordion-${contentKey}`}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    {accordionContent['header']}
                                </AccordionSummary>
                                <AccordionDetails>
                                    <hr/>
                                    <div dangerouslySetInnerHTML={{__html: accordionContent['html']}}/>
                                </AccordionDetails>
                            </Accordion>
                        )
                    }

                    contentKey++;
                });

            return(
                <>
                    {components}
                </>
            )
        } else {
            return(
                <div dangerouslySetInnerHTML={{__html: transcriptContent}}/>
            )
        }

    }

    /* --------------------------------- */

    // there are inputs where we only get the right columns
    // right column values are contained in odd inputs
    function isOdd(n: number) {
        return Math.abs(n % 2) === 1;
    }

    useLayoutEffect(()=> {
        const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms))
        async function getSupportingContent(){
            let currentStep: string = `${context.currentWeekNo}${context.currentTaskNo}${context.currentStepNo}`
            //console.log('layoutEffect', currentStep);
            if(currentStep === "162")
            {

                await sleep(3000)
                let appService = new AppService();
                const content = await appService.getSupportingContent("161");
                // let strSavedReponse: string = content.data.payload.saved_response;
                console.log(content)
                let savedResponse: any
                try {
                    savedResponse = JSON.parse(content.data.payload.saved_response)
                }
                catch (e) {
                    savedResponse = {}
                }

                let contentObj: ISupportingContent = {
                    "161": savedResponse
                }
                setSupportContent(contentObj)
            }

            if(currentStep === "1135")
            {
                let appService = new AppService();
                const content0 = await appService.getSupportingContent("1132");
                const content1 = await appService.getSupportingContent("1133");
                const content2 = await appService.getSupportingContent("1134");

                let savedResponse0 = content0.data.payload.saved_response
                let savedResponse1 = content1.data.payload.saved_response
                let savedResponse2 = content2.data.payload.saved_response


                let contentObj: ISupportingContent = {
                    "1132": savedResponse0,
                    "1133": savedResponse1,
                    "1134": savedResponse2
                }
                setSupportContent(contentObj)
            }

            if(currentStep==="2100") {
                let appService = new AppService();
                const content = await appService.getSupportingContent("291");
                let savedResponse = content.data.payload.saved_response

                // this step is expecting object
                let resultObj = JSON.parse(savedResponse)
                let surveyResult = resultObj['surveyResult']
                // console.log('savedResponse ==> ', savedResponse, 'result ==> ', surveyResult['highestRank']);
                setHighestRank(surveyResult['highestRank'])
            }

            if(currentStep==="2101") {
                let appService = new AppService();
                const content = await appService.getSupportingContent("293");
                let savedResponse = content.data.payload.saved_response

                // this step is expecting object
                let resultObj = JSON.parse(savedResponse)
                let surveyResult = resultObj['surveyResult']
                // console.log('savedResponse ==> ', savedResponse, 'result ==> ', surveyResult['highestRank']);
                setHighestRank(surveyResult['highestRank'])
            }


            if(currentStep === "442"){

                let appService = new AppService();
                const content = await appService.getSupportingContent("441");
                let savedResponse = content.data.payload.saved_response
                let contentObj: ISupportingContent = {
                    "441": savedResponse
                }
                setSupportContent(contentObj)
            }

            if(currentStep === "462"){

                let appService = new AppService();
                const content = await appService.getSupportingContent("461");
                let savedResponse = content.data.payload.saved_response
                let contentObj: ISupportingContent = {
                    "461": savedResponse
                }
                setSupportContent(contentObj)
            }


            if(currentStep === "474"){

                let appService = new AppService();
                const content = await appService.getSupportingContent("473");
                let savedResponse = content.data.payload.saved_response
                let contentObj: ISupportingContent = {
                    "473": savedResponse
                }
                setSupportContent(contentObj)
            }



        }
        getSupportingContent();

    },[context.currentStepNo, context.currentTaskNo, context.currentWeekNo]);

    return(
        <div className={'transcript'}>
            <div className={'header'}>
                <div className={'header-content'}>
                    <div className={'title'}>
                        {props.header}
                    </div>
                </div>
            </div>
            <div className={'transcript-content'}>
                <div className={'transcript-text'}>
                    {renderContent(finalTranscript)}
                    <div className={'transcript-action-space'}/>
                    <div className={'transcript-action-area'}>
                        <CardActionArea className={'transcript-previous-button'} onClick={props.moveBack}>
                            Previous
                        </CardActionArea>
                        <CardActionArea className={'transcript-button'} onClick={props.moveNext}>
                            {/*{(props.buttonLabel) ? props.buttonLabel : "Next"}*/}
                            Next
                        </CardActionArea>
                    </div>
                    <div className={'mobile-spacing'}/>
                </div>
            </div>

        </div>
    );
}

export default Transcript;